import { render, staticRenderFns } from "./PhotoView.vue?vue&type=template&id=73260136&scoped=true&"
import script from "./PhotoView.vue?vue&type=script&lang=js&"
export * from "./PhotoView.vue?vue&type=script&lang=js&"
import style0 from "./PhotoView.vue?vue&type=style&index=0&id=73260136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73260136",
  null
  
)

export default component.exports